var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('money',_vm._b({staticClass:"form-control",attrs:{"readonly":_vm.readonly},model:{value:(_vm.formattedValue),callback:function ($$v) {_vm.formattedValue=$$v},expression:"formattedValue"}},'money',_vm.money,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }